import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { EnquiryForm } from '../components/forms/EnquiryForm';

export default function DeposerCVPage() {
  return <div className="min-h-screen bg-white">
    <Header />
    <main id="main-content" tabIndex={-1}>
      <section className="bg-[#E30022] text-white py-12 sm:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 data-testid="cv-page-title" className="text-4xl sm:text-5xl lg:text-6xl font-serif mb-4">Déposez votre CV</h1>
          <p data-testid="cv-page-description" className="text-base sm:text-lg">Rejoignez notre vivier de talents et donnez une nouvelle perspective à votre carrière.</p>
        </div>
      </section>
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16"><EnquiryForm kind="cv" /></section>
    </main>
    <Footer />
  </div>;
}